"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _utilMUa = require("@dp/util-m-ua");

var _utilMUa2 = _interopRequireDefault(_utilMUa);

var _utm = require("./utm");

var _utm2 = _interopRequireDefault(_utm);

var _baseOpUrl = require("@dp/base-op-url");

var _baseOpUrl2 = _interopRequireDefault(_baseOpUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ua = (0, _utilMUa2.default)();

var locObj = new _baseOpUrl2.default(location.href);
var extraUa = (locObj.search('oss') == '1' ? 'oss' : null) || _utm2.default[locObj.search('utm_source')];
var mtLch = locObj.search('lch');
var ossWhiteList = [1200916, 1200917, 1244099, 1244095];
var utmHardCode = { '1215997': 'qztf1' };

(0, _keys2.default)(utmHardCode).forEach(function (u) {
	var exp = new RegExp("\/" + u + "\/");
	if (exp.test(location.href) && !mtLch) {
		console.log("命中UTM白名单");
		mtLch = utmHardCode[u];
	}
});

var AJAX_ENUM = [{
	dp: "//i.dianping.com/list",
	dptest: "//i.51ping.com/list"
}, {
	dp: "//promo.dianping.com/list",
	dptest: "//promo.51ping.com/list"
}, {
	dp: "//i.dianping.com/mtlist",
	dptest: "//i.51ping.com/mtlist",
	mt: "//i.meituan.com/mtlist",
	mttest: "//test.i.meituan.com/mtlist"
}, {
	dp: "//promo.dianping.com/mtlist",
	dptest: "//promo.51ping.com/mtlist",
	mt: "//i.meituan.com/mtlist",
	mttest: "//test.i.meituan.com/mtlist"
}, {
	dp: "//promo.dianping.com/services",
	dptest: "//promo.51ping.com/services",
	mt: "//i.meituan.com/services",
	mttest: "//test.i.meituan.com/services"
}];

var Ur = module.exports = function (url) {
	return _webUr(url, AJAX_ENUM);
};

function regFormat(url) {
	return url.replace("?", "\\?");
}

function _webUr(url, enum_arrs) {
	var result = void 0;

	enum_arrs.some(function (it) {
		for (var key in it) {
			var value = it[key];
			if (~url.indexOf(value)) {
				var path = url.replace(new RegExp("[^/]*?" + regFormat(value)), "");

				var prefix = ua.source == "meituan" ? ~location.host.indexOf("test") ? it["mttest"] : it["mt"] : ua.source == "dianping" ? ~location.host.indexOf("51ping") ? it["dptest"] : it["dp"] : it["dptest"];

				if (prefix) {
					result = prefix + path;
					return true;
				}
			}
		}
		return false;
	});

	if (!result) console.log(url + "\u4E0D\u5B58\u5728\u9690\u5C04\u57DF\u540D\u4E2D");
	return result || url;
}

function _ossUr(obj) {
	var wxpush = false;
	ossWhiteList.forEach(function (it) {
		var exp = new RegExp("\/" + it + "\/");
		if (exp.test(location.href)) {
			wxpush = true;
		}
	});

	if (extraUa == "oss") {
		wxpush = true;
	}

	if (wxpush) {
		switch (ua.source) {
			case "meituan":
				return obj["mtoss"];
			case "dianping":
				return obj['dposs'];
			default:
				return obj["dposs"];
		}
	} else {
		return false;
	}
}

function _appUr(obj) {
	return ua.type == "dpapp" ? obj["dpapp"] : ua.type == "mtgroup" ? obj["mtgroup"] : false;
}

var SKIP_ENUM = {
	deal: {
		dp: "//m.dianping.com/tuan/deal/{id}",
		dptest: "//m.51ping.com/tuan/deal/{id}",
		mt: "//i.meituan.com/deal/{id}.html",
		mttest: "//test.i.meituan.com/deal/{id}.html",
		dpapp: "dianping://tuandeal?id={id}",
		mtgroup: "imeituan://www.meituan.com/deal?did={id}&channel={channel}",

		mtoss: parseInt((ua.version || "").replace(/\./g, "")) >= 730 ? "//tpl.dianping.com/firework/callApp?type=meituan&appurl=imeituan%3A%2F%2Fwww.meituan.com%2Fgc%2Fdeal%2Fdetail%3Flch%3D" + mtLch + "%26did%3D{id}%26channel%3D{channel}&weburl=%2F%2Fi.meituan.com%2Fdeal%2F{id}.html" : "//tpl.dianping.com/firework/callApp?type=meituan&appurl=imeituan%3A%2F%2Fwww.meituan.com%2Fdeal%3Flch%3D" + mtLch + "%26did%3D{id}%26channel%3D{channel}&weburl=%2F%2Fi.meituan.com%2Fdeal%2F{id}.html",
		dposs: "//tpl.dianping.com/firework/callApp?type=dianping&appurl=dianping%3A%2F%2Ftuandeal%3Futm%3D" + mtLch + "%26id%3D{id}&weburl=%2F%2Fm.dianping.com%2Ftuan%2Fdeal%2F{id}"
	},
	shop: {
		dp: "//m.dianping.com/shop/{id}",
		dptest: "//m.51ping.com/shop/{id}",
		mt: "//i.meituan.com/poi/{id}",
		mttest: "//test.i.meituan.com/poi/{id}",
		dpapp: "dianping://shopinfo?shopid={id}&id={id}",
		mtgroup: "imeituan://www.meituan.com/merchant?id={id}&showtype={showtype}",

		mtoss: "//tpl.dianping.com/firework/callApp?type=meituan&appurl=imeituan%3A%2F%2Fwww.meituan.com%2Fmerchant%3Flch%3D" + mtLch + "%26id%3D{id}%26showtype%3D{showtype}&weburl=%2F%2Fi.meituan.com%2Fpoi%2F{id}",
		dposs: "//tpl.dianping.com/firework/callApp?type=dianping&appurl=dianping%3A%2F%2Fshopinfo%3Futm%3D" + mtLch + "%26id%3D{id}&weburl=%2F%2Fm.dianping.com%2Fshop%2F{id}"
	},
	web: {
		dp: "{url}",
		dptest: "{url}",
		mt: "{url}",
		mttest: "{url}",
		dpapp: "dianping://web?shark=1&url={{url}}",
		mtgroup: "imeituan://www.meituan.com/web?shark=1&url={{url}}",

		mtoss: "//tpl.dianping.com/firework/callApp?type=meituan&appurl=imeituan%3A%2F%2Fwww.meituan.com%2Fweb%3Fshark%3D1%26lch%3D" + mtLch + "%26url%3D~url~&weburl={{url}}",
		dposs: "//tpl.dianping.com/firework/callApp?type=dianping&appurl=dianping%3A%2F%2Fweb%3Futm%3D" + mtLch + "%26shark%3D1%26url%3D~url~&weburl={{url}}"
	},
	schema: {
		dp: "//tpl.dianping.com/firework/callApp?type=dianping&appurl={{url}}&weburl=" + encodeURIComponent(location.href),
		dptest: "//tpl.dianping.com/firework/callApp?type=dianping&appurl={{url}}&weburl=" + encodeURIComponent(location.href),
		mt: "//tpl.dianping.com/firework/callApp?type=meituan&appurl={{url}}&weburl=" + encodeURIComponent(location.href),
		mttest: "//tpl.dianping.com/firework/callApp?type=meituan&appurl={{url}}&weburl=" + encodeURIComponent(location.href),
		dpapp: "{url}",
		mtgroup: "{url}",

		mtoss: "//tpl.dianping.com/firework/callApp?type=meituan&appurl={{url}}&weburl=" + encodeURIComponent(location.href),
		dposs: "//tpl.dianping.com/firework/callApp?type=dianping&appurl={{url}}&weburl=" + encodeURIComponent(location.href)
	},

	search: {
		dp: "//m.dianping.com/shoplist/1/r/0/c/30/s/s_-1?keyword={{keyword}}",
		dptest: "//m.51ping.com/shoplist/1/r/0/c/30/s/s_-1?keyword={{keyword}}",
		dpapp: "dianping://searchshoplist?sort=0&categoryid=30&keyword={{keyword}}"
	}
};

function _handler(value) {
	return function (opt) {
		var matchStr = _appUr(value) || _ossUr(value) || _webUr(value["dp"], [value]) || false;

		for (var k in opt) {
			var v = opt[k];
			matchStr = matchStr.replace(new RegExp("{{" + k + "}}", "g"), encodeURIComponent(v)).replace(new RegExp("{" + k + "}", "g"), v);
			matchStr = matchStr.replace(new RegExp("~" + k + "~", "g"), encodeURIComponent(encodeURIComponent(v)));
		}
		return matchStr.replace(/\&?\{[^\}]+\}/g, "");;
	};
}

for (var key in SKIP_ENUM) {
	var value = SKIP_ENUM[key];
	Ur[key] = _handler(value);
}

Ur.methodExtend = function (key, value) {
	if (!Ur[key]) {
		Ur[key] = _handler(value);
	} else {
		console.log(key + "\u65B9\u6CD5\u5DF2\u5B58\u5728");
	}
};

Ur.AjaxExtend = function (value) {
	AJAX_ENUM.push(value);
};

function normalize_array(parts) {
	var up = 0;
	var i = parts.length - 1;
	for (; i >= 0; i--) {
		var last = parts[i];
		if (last === '.') {
			parts.splice(i, 1);
		} else if (last === '..') {
			parts.splice(i, 1);
			up++;
		} else if (up) {
			parts.splice(i, 1);
			up--;
		}
	}

	while (up--) {
		parts.unshift('..');
	}

	return parts;
}

Ur.resolve = function (from, to) {
	var parts = (from + '/' + to).split('/').filter(Boolean);
	return normalize_array(parts).join('/');
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/url-rewrite/dist/index.js
// module id = 230
// module chunks = 0 9